<template>
  <div>
    <base-list-management
      ref="baseListManagement"
      :configData.sync="configData"
    >
      <div slot="custom-operate">
        <el-dropdown @command="handleDropdownCommand">
          <el-button
            type="primary"
            icon="el-icon-arrow-down"
            icon-position="right"
            >车源信息发布</el-button
          >
          <el-dropdown-menu slot="dropdown">
            <el-dropdown-item
              v-for="item in LEASE_TYPE_OPTIONS"
              :command="item.value"
              :key="item.value"
              >{{ `${item.label}方案` }}</el-dropdown-item
            >
          </el-dropdown-menu>
        </el-dropdown>
      </div>
    </base-list-management>
  </div>
</template>
<script>
// eslint-disable-next-line import/no-cycle
import { infoManageList, infoManageDelete } from '@/api/carResource/index.js'
import { PUBLISH_STATUS, PUBLISH_STATUS_VALUE } from './const.js'
import { LEASE_TYPE_OPTIONS } from '../const.js'
import { mapGetters } from 'vuex'
import { operateMaxShowLength } from '@/store/dict/config'

export default {
  data() {
    return {
      LEASE_TYPE_OPTIONS,
      configData: {
        isShowDepartment: false,
        formData: {
          list: [
            {
              el: 'input',
              itemConfig: {
                label: '标题名称',
                prop: 'title',
              },
              elConfig: {
                clearable: true,
                placeholder: '请输入',
              },
            },
            {
              itemConfig: {
                prop: 'brandSeriesModel',
              },
              elConfig: {
                showModel: true,
              },
              render: 'CarBrandSeriesModel',
            },
            {
              el: 'select',
              itemConfig: {
                label: '方案类型',
                prop: 'leaseType',
              },
              elConfig: {
                clearable: true,
                placeholder: '请选择',
                options: {
                  label: 'label',
                  value: 'value',
                  list: LEASE_TYPE_OPTIONS,
                },
              },
            },
            {
              el: 'select',
              itemConfig: {
                label: '交车城市',
                prop: 'transactionCityCode',
              },
              elConfig: {
                clearable: true,
                filterable: true,
                options: {
                  label: 'city',
                  value: 'adcode',
                  list: [],
                },
              },
            },
            {
              el: 'select',
              itemConfig: {
                label: '发布状态',
                prop: 'state',
              },
              elConfig: {
                clearable: true,
                placeholder: '请选择',
                options: {
                  label: 'label',
                  value: 'value',
                  list: PUBLISH_STATUS,
                },
              },
            },
          ],
          dealWithSearch: (params) => {
            const { brandSeriesModel } = params
            const searchParams = {
              ...params,
              brandId: brandSeriesModel.brandId,
              seriesId: brandSeriesModel.seriesId,
              modelId: brandSeriesModel.modelId,
            }
            delete searchParams.brandSeriesModel
            return searchParams
          },
          customizeReset: () => {
            this.$refs.baseListManagement.setItemData({
              elConfigKey: 'value',
              key: 'brandSeriesModel',
              data: {},
            })
          },
        },
        tableData: {
          columns: [
            {
              name: 'carResourceId',
              columnProps: {
                prop: 'carResourceId',
                label: '车源信息ID',
                width: '100px',
              },
            },
            {
              name: 'title',
              columnProps: {
                prop: 'title',
                label: '标题名称',
              },
            },
            {
              name: 'brandName',
              columnProps: {
                prop: 'brandName',
                label: '品牌',
              },
            },
            {
              name: 'seriesName',
              columnProps: {
                prop: 'seriesName',
                label: '车系',
              },
            },
            {
              name: 'modelName',
              columnProps: {
                prop: 'modelName',
                label: '车型',
              },
            },
            {
              name: 'leaseType',
              columnProps: {
                prop: 'leaseType',
                label: '方案类型',
              },
              getText: ({ row }) =>
                LEASE_TYPE_OPTIONS.find((item) => item.value === row.leaseType)
                  ?.label,
            },
            {
              name: 'transactionCityName',
              columnProps: {
                prop: 'transactionCityName',
                label: '交车城市',
              },
            },
            {
              name: 'stateName',
              columnProps: {
                prop: 'stateName',
                label: '发布状态',
              },
            },
            {
              name: 'createUser',
              columnProps: {
                prop: 'createUser',
                label: '创建人',
              },
            },
            {
              name: 'latestUpdateTime',
              columnProps: {
                prop: 'latestUpdateTime',
                label: '最后更新时间',
                width: '160px',
              },
            },
            {
              name: 'operate',
              type: 'operate',
              columnProps: {
                label: '操作',
                fixed: 'right',
                width: 240,
              },
              maxShowLength: operateMaxShowLength,
              getOperateList: ({ row }) => {
                const btns = []
                if (this.judgePermission('purchase_info_manage_btn_detail')) {
                  btns.push({
                    name: 'detail',
                    label: '详情',
                    action: () => this.handleDetailBtnClick(row),
                  })
                }
                // 状态是待发布、已发布 则显示
                if (
                  [
                    PUBLISH_STATUS_VALUE.WAIT_PUBLISH,
                    PUBLISH_STATUS_VALUE.PUBLISH,
                  ].includes(row.state)
                ) {
                  if (this.judgePermission('purchase_info_manage_btn_edit')) {
                    btns.push({
                      name: 'edit',
                      label: '编辑',
                      action: () => this.handleEditBtnClick(row),
                    })
                  }
                  if (this.judgePermission('purchase_info_manage_btn_delete')) {
                    btns.push({
                      name: 'delete',
                      label: '删除',
                      action: () => this.handleDeleteBtnClick(row),
                    })
                  }
                }
                return btns
              },
            },
          ],
          apiFn: infoManageList,
        },
      },
    }
  },
  computed: {
    ...mapGetters(['allCities']),
  },
  watch: {
    allCities: {
      handler(val) {
        // 交车城市枚举填充
        this.configData.formData.list.find(
          (item) => item.itemConfig.prop === 'transactionCityCode',
        ).elConfig.options.list = val
      },
      immediate: true,
    },
  },
  methods: {
    handleDropdownCommand(command) {
      this.$router.push({
        path: '/purchaseProvide/infoManage/publish',
        query: { leaseType: command },
      })
    },
    handleDetailBtnClick({ carResourceId, leaseType }) {
      this.$router.push({
        path: '/purchaseProvide/infoManage/detail',
        query: { carResourceId, leaseType },
      })
    },
    handleEditBtnClick({ carResourceId }) {
      this.$router.push({
        path: '/purchaseProvide/infoManage/publish',
        query: { carResourceId },
      })
    },
    handleDeleteBtnClick(row) {
      this.$confirm('是否删除？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
      })
        .then(() => {
          infoManageDelete({ id: row.carResourceId }).then((res) => {
            if (res?.code === 1) {
              this.$message.success('删除成功')
              // 刷新列表
              this.$refs.baseListManagement.searchForm()
            }
          })
        })
        .catch(() => null)
    },
  },
}
</script>
